import { useSelector } from 'react-redux';

import { RootState } from '@lib/redux.lib/store';

import { FEATURE_PERMISSIONS_PER_ROLE } from './permissions';

type UseUserRoleResult = {
  hasPermission: boolean;
  currentUserRole: CastingRoles;
};

export const useUserRole = (
  page: string,
  permission: keyof Permission
): UseUserRoleResult => {
  const userRole = useSelector(
    (state: RootState) => state?.app?.user?.profile?.casting_role
  ) as CastingRoles | undefined;

  let hasPermission = false;

  if (!userRole) {
    console.log('User role is undefined');
    return { hasPermission: false, currentUserRole: undefined };
  }
  const featurePermissions = FEATURE_PERMISSIONS_PER_ROLE[userRole];
  if (!featurePermissions) {
    console.log(`No permissions found for role: ${userRole}`);
    return { hasPermission: false, currentUserRole: userRole };
  }
  const pagePermissions = featurePermissions[page];
  if (!pagePermissions) {
    console.log(`No permissions found for page: ${page}`);
    return { hasPermission: false, currentUserRole: userRole };
  }
  hasPermission = pagePermissions[permission];
  if (hasPermission === undefined) {
    console.log(`No permission found for ${permission} on page: ${page}`);
    hasPermission = false;
  } else {
    hasPermission = !!hasPermission;
  }

  return { hasPermission: hasPermission, currentUserRole: userRole };
};
